import { gql } from '@apollo/client';
import { DOCUMENT_FRAGMENT, BLOB_FRAGMENT } from 'graphql/document/DocumentFragments';

export const PARTNER_ACCOUNT_FRAGMENT = gql`
  fragment partnerAccountFields on PartnerAccount {
    id
    partnerProfile {
      id
      name
      thumbnailBlob {
        ...blobFields
      }
    }
  }
  ${BLOB_FRAGMENT}
`;

export const PARTNER_DOCUMENT_FRAGMENT = gql`
  fragment partnerDocumentFields on Document {
    ...documentFields
    publicationStartDate
    uri
  }
  ${DOCUMENT_FRAGMENT}
`;

export const PARTNER_CONTENT_FRAGMENT = gql`
  fragment partnerContentFields on Content {
    id
    blob {
      ...blobFields
    }
    content
    publicationStartDate
    thumbnailBlob {
      ...blobFields
    }
    title
  }
  ${BLOB_FRAGMENT}
`;